import React from 'react';
import { Link } from 'react-router-dom';

export default function StatCard({
  icon,
  label,
  value,
  subtext,
  progress,
  to,
  className = '',
}) {
  const content = (
    <div className={`card p-5 h-full flex flex-col justify-between ${to ? 'card-hover cursor-pointer' : ''} ${className}`}>
      <div>
        {icon && (
          <div className="w-8 h-8 rounded-[8px] bg-[var(--teal-050)] border border-[var(--teal-100)] text-[var(--teal-600)] flex items-center justify-center mb-3">
            {icon}
          </div>
        )}
        <div
          className="text-2xl sm:text-3xl font-bold text-[var(--navy-950)] tracking-tight"
          style={{ fontFamily: 'var(--font-heading)' }}
        >
          {value ?? '-'}
        </div>
      </div>

      <div className="mt-2">
        {label && (
          <p className="text-[12.5px] font-medium text-[var(--ink-soft)] leading-snug">
            {label}
          </p>
        )}
        {subtext && (
          <p className="text-[11.5px] text-[var(--ink-faint)] mt-0.5">
            {subtext}
          </p>
        )}
        {progress != null && (
          <div className="w-full bg-[var(--line-soft)] h-1.5 rounded-full mt-2.5 overflow-hidden">
            <div
              className="h-full rounded-full transition-all duration-500"
              style={{
                width: `${Math.min(100, Math.max(0, progress))}%`,
                background: 'linear-gradient(90deg, var(--teal-500), var(--teal-600))',
              }}
            />
          </div>
        )}
      </div>
    </div>
  );

  if (to) {
    return <Link to={to} className="block no-underline">{content}</Link>;
  }
  return content;
}
